























import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class CreateRoleDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private getList!: () => Promise<void>

  private name = ''
  private role = ''
  private requireCenter = false
  private isRequireCenter = false
  private loading = false
  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get createUserDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'เพิ่ม',
          action: this.createRoleAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }
  @Getter('userprofile/getProfile')
  private profile!: any


  get userProfile() {
    return this.profile
  }

  get invalidateInput() {
    return _.some(
        [
          this.validateInputFromType('string', this.name, true),
        ],
        (item) => item !== true,
    )
  }

  get isAdmin() {
    if (this.role === 'ผู้ดูแลระบบ') {
      return true
    } else {
      return false
    }
  }

  private async createRoleAction() {
    const url = process.env.VUE_APP_API_URL + '/v1/role'
    const data = {
      name: this.name,
      requireCenter: this.role === 'ผู้ดูแลระบบ' ? this.isRequireCenter : true,
    }
    this.loading = true
    try {
      await HttpRequestServiceWithToken.post(url, data, async () => {
        this.updateSnackbar({txt: 'บันทึกหน้าที่สำเร็จ.', type: 'success'})
        await this.callback()
        this.loading = false
        this.closeDialog()
      })
    } catch (e) {
      this.loading = false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  private async created() {
    this.name = ''
    this.role = this.userProfile.role && this.userProfile.role.name || ''
  }
}
